import { render, staticRenderFns } from "./EmployeeAssignedFormsList.vue?vue&type=template&id=35a7fc48&scoped=true&"
import script from "./EmployeeAssignedFormsList.vue?vue&type=script&lang=js&"
export * from "./EmployeeAssignedFormsList.vue?vue&type=script&lang=js&"
import style0 from "./EmployeeAssignedFormsList.vue?vue&type=style&index=0&id=35a7fc48&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35a7fc48",
  null
  
)

export default component.exports